import React, { Component, useMemo, useState } from 'react'
import SRCards from '../../components/SRCards'
import {
    Button, Container, FormControl, InputLabel, Select, MenuItem,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar,
} from '@material-ui/core'

import CommonServiceApi from '../../services/common-service';
import { Alert } from '@material-ui/lab';
import SelectCompany from '../../components/SelectCompany';
import LoadingModal from '../../components/LoadingModal';
export default function ESIndexList() {
    const [table, setTable] = useState('');
    const [dialog, setDialog] = useState(false);
    const [snackBar, setSnackBar] = useState('');
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pageResponse, setPageResponse] = useState('');
    const [errorDialog, setErrorDialog] = useState(false);
    const [loadingModalState, setLoadingModalState] = useState<boolean>(false);
    const apiservices = new CommonServiceApi();
    const pricebookIndexes = useMemo<string[]>(
        () => [
            "pricebook",
            "pbMaterial",
            "pbGroup",
            "pbInventory",
            "pbVendor",
            "pbCategory",
        ],
        []
    );
    const handleChange = (e: any) => {
        switch (e.target.value) {
            case 1:
                setTable('customerAddress');
                break;
            case 2:
                setTable('customer');
                break;
            case 3:
                setTable('invoice');
                break;
            case 4:
                setTable('estimate');
                break;
            case 5:
                setTable('independentInvoice');
                break;
            case 6:
                setTable('independentEstimate');
                break;
            case 7:
                setTable('ticket');
                break;
            case 8:
                setTable('jobHistory');
                break;
            case 9:
                setTable('salesTax');
                break;
            case 10:
                setTable('serviceAgreement');
                break;
            case 11:
                setTable('qbHistory');
                break;
            case 12:
                setTable('flatRate');
                break;
            case 13:
                setTable('pricebook');
                break;
            case 14:
                setTable('pbMaterial');
                break;
            case 15:
                setTable('pbGroup');
                break;
            case 16:
                setTable('pbInventory');
                break;
            case 17:
                setTable('pbVendor');
                break;
            case 18:
                setTable('pbCategory');
                break;
            case 19:
                setTable('assignment');
        }
    }
    const confirm = (e: any) => {
        var companyId = localStorage.getItem('selectedCompanyId');
        if (table && companyId) {
            let res = `This operation will rebuild the elesticsearch cache of ${table}. Are you sure?`
            setDialog(true);
            setConfirmMsg(res);
        }
        else {
            setErrorDialog(true);
        }
        return
    }
    const cancel = () => {
        setDialog(false);
        setSnackBar('info');
        setPageResponse(`Rebuild Cancelled.`);
    }
    const sync = async () => {
        setLoadingModalState(true);
        let companyId = localStorage.getItem('selectedCompanyId');
        let response = await apiservices.esIndex(companyId, table);
        if (
            (response && typeof response === "object" && response.address
                ? response.address._shards &&
                  response.address._shards.failed === 0
                : response._shards && response._shards.failed === 0) ||
            (typeof response.count === "number" &&
                pricebookIndexes.includes(table))
        ) {
            setDialog(false);
            setSnackBar('success');
            setPageResponse("Cache Rebuilt Successfully.")
        }
        else {
            let msg;
            if (response && response.message && response.description) {
                msg = `Cache Rebuild Failed: ${response.message} - ${response.description}`
            } else {
                msg = `Cache Rebuild Failed.`
            }
            setDialog(false);
            setSnackBar('error');
            setPageResponse(msg);
        }
        setLoadingModalState(false);
    }
    const onClose = () => {
        setErrorDialog(false)
    }
    return (
        <>
            <SRCards />
            <Container>
                <LoadingModal openState={loadingModalState}/>
            <SelectCompany/>
            <br/><br/>
                <Button className='esindex_body'
                    onClick={confirm}
                    style={{ margin: 10 }}
                    variant='outlined'> Rebuild ES Index</Button>
                <br></br><br></br>
                <FormControl fullWidth className='esindex_body'>
                    <InputLabel id="demo-simple-select-label">Modules</InputLabel>
                    <Select
                        onChange={handleChange}
                    >
                        <MenuItem value={1}>Customer Address</MenuItem>
                        <MenuItem value={2}>Customer</MenuItem>
                        <MenuItem value={3}>Invoice</MenuItem>
                        <MenuItem value={4}>Estimate</MenuItem>
                        <MenuItem value={5}>Independent Invoice </MenuItem>
                        <MenuItem value={6}>Independent Estimate </MenuItem>
                        <MenuItem value={7}>Ticket</MenuItem>
                        <MenuItem value={8}>Job History</MenuItem>
                        <MenuItem value={9}>Sales Tax</MenuItem>
                        <MenuItem value={10}>Service Agreement</MenuItem>
                        <MenuItem value={11}>QB History</MenuItem>
                        <MenuItem value={12}>Flat Rate Item</MenuItem>
                        <MenuItem value={13}>Price Book</MenuItem>
                        <MenuItem value={14}>Price Book Material</MenuItem>
                        <MenuItem value={15}>Price Book Group</MenuItem>
                        <MenuItem value={16}>Price Book Inventory</MenuItem>
                        <MenuItem value={17}>Price Book Vendor</MenuItem>
                        <MenuItem value={18}>Price Book Category</MenuItem>
                        <MenuItem value={19}>Assignment</MenuItem>
                    </Select>
                </FormControl>
                <br /> <br /> <br /> <br />
                <Dialog
                    open={dialog}
                    onClose={() => {
                        setDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {'Confirmation!'}
                    </DialogTitle>
                    <DialogContent>
                        {confirmMsg}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => { sync() }}
                        >
                            Confirm
                        </Button>
                        <Button
                            onClick={() => cancel()}
                            autoFocus
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={errorDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                        Please select Company and Table before rebuilding the redis cache.
                    </DialogContent>
                    <Button onClick={onClose}>Ok</Button>
                </Dialog>
                <Snackbar
                    open={snackBar === '' ? false : true}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setSnackBar('')
                    }}
                >
                    <Alert
                        severity={snackBar === 'error' ? 'error' : 'success'}
                        onClose={() => {
                            setSnackBar('')
                        }
                        }>
                        {pageResponse}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    )
}
